
import { QueryClient } from "react-query";
import { AxiosError } from "axios";

// Utils
import { QUERY_CLIENT_RETRY_ATTEMPS, QUERY_CLIENT_STALE_TIME } from "../utils/constants.util";


export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {  
        if (error instanceof AxiosError) {
          if (error.response.status === 401) return false;
        }

        return failureCount < QUERY_CLIENT_RETRY_ATTEMPS;
      },
      staleTime: QUERY_CLIENT_STALE_TIME,
    },
  },
});


/////// NOTAS:  ///////
// refetchOnWindowFocus: false : Desactiva la revalidación automática de las consultas cuando el usuario vuelve a enfocar la ventana del navegador.
// retry: Define la lógica de reintentos en caso de que una consulta falle.
// QUERY_CLIENT_RETRY_ATTEMPS: se usa para reintentar hasta al canzar ese maximo de intento
// staleTime: Establece el tiempo que los datos seran considerados frescos